import axios from 'axios';
import config from '@/config';
const baseDomain = config.baseDomain;
const environment = config.environment;
const baseURL = `${
	environment === 'local' ? 'http://localhost:8080' : baseDomain
}/version.json`;

export function makeCallToVersionAPI() {
	return axios
		.get(baseURL)
		.then((response) => {
			return {
				version: response.data.data.Version,
				status: response.status,
			};
		})
		.catch(() => {
			if (environment === 'local') {
				return {
					version: 'Development',
					status: 200,
				};
			}
			return {
				version: 'Beta',
				status: 404,
			};
		});
}
